import { appendPx, belowBreakpoint, fadeColor, getColor, lightenColor, styled } from 'imaginarity-react-ui';
import { SlideContainerDimensions } from './SlideShowContent';
import { HorizontalAlignment, VerticalAlignment } from 'collaboration-service';

const calcMarginLeft = (dim: SlideContainerDimensions) => {
    return (dim.viewMode === "Desktop" || dim.viewMode === "Tablet horizontal" ? 0.06 : 0.01) * dim.width;
}

export class SlideshowSC {
    public static SlideContainerDesktop = styled.div` 
    display: -ms-grid;
    display: grid;
    height: 100%; //calc(((var(--grid-cell-height)) * 12 * 0.7));
    position: relative;
    grid-template-columns: [x0] 1fr [x1] 1fr [x2] 1fr [x3] 1fr [x4] 1fr [x5] 1fr [x6] 1fr [x7] 1fr [x8] 1fr [x9] 1fr [x10] 1fr [x11] 1fr [x12];
    grid-template-rows: [y0] 1fr [y1] 1fr [y2] 1fr [y3] 1fr [y4] 1fr [y5] 1fr [y6] 1fr [y7] 1fr [y8] 1fr [y9] 1fr [y10] 1fr [y11] 1fr [y12];
    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    -ms-grid-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
`;
    public static SlideContainerMobile = styled.div` 
    display: -ms-grid;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 767px));
    -ms-grid-columns: repeat(auto-fill, minmax(200px, 767px));
`;
    public static SlideContainerTablet = styled.div` 
    display: -ms-grid;
    display: grid;
    grid-template-columns: [x0] 1fr [x1] 1fr [x2] 1fr [x3] 1fr [x4] 1fr [x5] 1fr [x6] 1fr [x7] 1fr [x8];
    grid-template-rows: [y0] max-content [y1] max-content [y2] max-content [y3] max-content [y4] max-content [y5] max-content [y6] max-content [y7] max-content [y8] max-content [y9] max-content [y10] max-content [y11] max-content [y12] max-content [y13] max-content [y14] max-content [y15] max-content [y16];
    -ms-grid-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    -ms-grid-rows: max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content;
`;
    public static SlideShowContainer = styled.div<{ isMobileView: boolean, isMobile: boolean }>` 
    width: 100%;
    //height: ${props => (props.isMobileView && !props.isMobile) ? "calc(100vh - " + appendPx(props.theme.headerHeight) + ")" : (props.isMobileView && props.isMobile) ? "calc(100vh - 95px - " + appendPx(props.theme.headerHeight) + ")" : "calc(100vh - " + appendPx(props.theme.headerHeight) + ")"};
    position: relative; 
    overflow: hidden;
`;
    public static SlideContainer = styled.div<{ dim: SlideContainerDimensions, height: number, isMobileView: boolean, isMobile: boolean }>`
    //margin-left: calc((100% - ${props => props.dim.width}px) / 2);
    display: grid;
    display: -ms-grid;
    grid-template-rows: ${props => (props.isMobileView && !props.isMobile) ? "calc((100vh - " + appendPx(props.theme.headerHeight) + " ) * 0.06) calc((100vh - " + appendPx(props.theme.headerHeight) + " ) * 0.88) calc((100vh - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : (props.isMobileView && props.isMobile) ? "calc((100vh - 95px - " + appendPx(props.theme.headerHeight) + " ) * 0.06) calc((100vh - 95px - " + appendPx(props.theme.headerHeight) + " ) * 0.88) calc((100vh - 95px - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : appendPx(props.height * 0.06) + " " + appendPx(props.height * 0.88) + " " + appendPx(props.height * 0.06)};
    //grid-template-columns: ${props => props.isMobileView && props.isMobile ? "2% 96% 2%" : "50px calc(" + props.dim.width + "px - 100px) 50px"};
    grid-template-columns: ${props => props.isMobileView && props.isMobile ? "2% 96% 2%" : "50px 1fr 50px"};
    width: 100%;
`;
    public static SlideTitleContainer = styled.div<{ height: number, isMobileView: boolean, isMobile: boolean }>`
    -ms-grid-row: 1;
    grid-row: 1;
    grid-column: 2;
    width: 100%;
    font-size: 1.1em;
    font-weight: 600;
    line-height: ${props => (props.isMobileView && !props.isMobile) ? "calc((100vh - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : (props.isMobileView && props.isMobile) ? "calc((100vh - 95px - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : appendPx(props.height * 0.06)};
`;
    public static SlideInsideGrid = styled.div<{ dim: SlideContainerDimensions, background: string }>`
    -ms-grid-row: 2;
    grid-row: 2;
    grid-column: 2;
    position: relative;
    background: ${props => props.background};
    /* overflow-y: auto; */

    width: 100%;
`;
    public static NavigationDots = styled.div<{ dim: SlideContainerDimensions }>`
    width: 100%;
    margin: auto;
    text-align: left;
    position: relative;
    grid-row: 3;
    grid-column: 2;
    -ms-grid-row: 3;    
    `;

    public static NavigationDot = styled.div`
    transition: all 0.2s ease-out;
    display: inline-block;
    cursor: pointer;
    margin: 0 3px;
    transform-origin: center;
    &:hover{
        svg{
            stroke: ${p => getColor(p, "@accent")};
            stroke-width: 3px;
        }
    }   
`;


    public static SlideNavigationLeft = styled.div<{ dim: SlideContainerDimensions, position: "left" | "right" }>`
    grid-row: 2;
    grid-column: 1;
    -ms-grid-row: 2;
    height: 100%;
    position: relative;
    svg{
        position: absolute;
        top: calc(50% - 10px);
        transform: translateY(-50%);
    }
    cursor: pointer;
`;
    public static SlideNavigationRight = styled.div<{ dim: SlideContainerDimensions, position: "left" | "right" }>`
    grid-row: 2;
    grid-column: 3;
    -ms-grid-row: 2;
    height: 100%;
    position: relative;
    svg{
        position: absolute;
        top: calc(50% - 10px);
        transform: translateY(-50%);
    }
    cursor: pointer;
`;
    public static SlidePagination = styled.div<{ dim: SlideContainerDimensions, height: number, isMobileView: boolean, isMobile: boolean }>`
    position: absolute;
    right: 50px;
    font-size: 1.1em;
    font-weight: 400;
    line-height: ${props => (props.isMobileView && !props.isMobile) ? "calc((100vh - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : (props.isMobileView && props.isMobile) ? "calc((100vh - 95px - " + appendPx(props.theme.headerHeight) + " ) * 0.06)" : appendPx(props.height * 0.06)};
    display: ${props => (props.dim.viewMode === "Desktop" || props.dim.viewMode === "Tablet horizontal" || props.dim.viewMode === "Tablet vertical" ? "inline-block" : "none")};
    button>div{margin: 0;}
`;
    public static InfoBoxContainer = styled.div`
    padding:10px;
    line-height:30px;
    width:100%;
    background:rgba(255,255,255,0.05);
    margin-top: 30px;
    color: rgba(255,255,255,0.8);
    bottom:0;
`;
    public static SlideTable = styled.div<{ type: string }>`
        display: grid;
        grid-template-columns: ${p => belowBreakpoint(p, "desktop") ? "1fr" : p.type === 'Template2' ? '1fr 1fr' : (p.type === 'Template5' ? '1fr 1fr 1fr' : (p.type === 'Template3' ? '1fr 2fr' : (p.type === 'Template4' ? '2fr 1fr' : '1fr')))};
        ${p => belowBreakpoint(p, "desktop") && "row-gap: 20px;"}
        column-gap: 20px;
        button>div{margin:0;}
        position: relative;
    `;
    public static EditContainer = styled.div`
        position: relative;
        background: ${p => getColor(p, "@mainBackground")};
        border: 1px solid ${p => getColor(p, "@middleLightGrey")};
        padding-bottom: 35px;
    `;
    public static EditContainerTopBar = styled.div`
        background: ${p => getColor(p, "@veryLightGrey")};
        width: 100%;
        border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
        height: 40px;
        margin-bottom: 1px;
        line-height: 40px;
    `;
    public static EditContainerFooterBar = styled(this.EditContainerTopBar)`
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid ${p => getColor(p, "@middleLightGrey")};
        border-bottom: none;
    `;

    public static PositionIconColored = styled.div`
        float: left;
        svg{
            .activeDot{
                stroke: ${p => getColor(p, "@accent")};
            }
        }
    `;
    public static Item = styled.div<{ marked: boolean }>`
        border:  1px solid ${p => p.marked ? getColor(p, "@accent") : getColor(p, "@middleLightGrey")};
        float: left;
        box-shadow: ${p => p.marked ? "0 6px 8px -6px #000" : "none"};
        margin: 10px;
        transform: translateX(-10px);
        padding: 1px;
        cursor: pointer;
        background: transparent;
        positikon: relative;
        transition: all 0.2s ease-out;
        .foot{
            transition: all 0.2s ease-out;
            background: ${p => p.marked ? fadeColor(p, "@accent", 80) : "inherit"};
            color: ${p => getColor(p, "@mainBackground")};
        }
            &:hover{
            border:  1px solid ${p => p.marked ? getColor(p, "@accent") : getColor(p, "@darkGrey")};
            .foot{
                transition: all 0.2s ease-out;
                background: ${p => p.marked ? fadeColor(p, "@accent", 80) : fadeColor(p, "@darkGrey", 80)};
                color: ${p => getColor(p, "@mainBackground")};
            }
        }
`;
    public static ItemFooter = styled.div`
        transition: all 0.2s ease-out;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        background: ${p => fadeColor(p, "@darkGrey", 10)};
        color: ${p => getColor(p, "@darkGrey")};
`;
    public static Container = styled.div<{ parts: number }>`
        display: grid;
        grid-template-columns: ${p => p.parts === 1 ? '1fr' : (p.parts === 2 ? '1fr 1fr' : '1fr 1fr 1fr')};
        height: 100%;
`;

    public static HotSpot = styled.div<{}>`
        color: ${p => getColor(p, "@accentBlack")};
`;
    public static GridColumn = styled.div`
        position: relative;
`;
    public static GridColumnPosition = styled.div<{ vAlign: VerticalAlignment, hAlign?: HorizontalAlignment }>`
        position: absolute;
        left: 0;
        right: 0;
        top: ${p => p.vAlign === "Top" ? 0 : p.vAlign === "Center" ? "50%" : "unset"} ;
        bottom: ${p => p.vAlign === "Bottom" ? 0 : "unset"};
        transform: translateY(${p => p.vAlign === "Center" ? "-50%" : 0});
        /* padding: 20px; */
        text-align: ${p => p.hAlign?.toLowerCase() ?? 'left'};
        /* overflow-y: auto; */
        max-height: 100%;
`;
    public static SlideContainerPrev = styled.div<{ dim: SlideContainerDimensions }>`
        margin-top: ${props => props.dim.marginTop}px;
        margin-left: ${props => props.dim.marginLeft}px;
        width: ${props => props.dim.width}px;
        height: ${props => props.dim.height}px;
        display: grid;
        display: -ms-grid;
        grid-template-rows: ${props => props.dim.height * 0.06}px ${props => props.dim.height * 0.88}px ${props => props.dim.height * 0.06}px;
`;
    public static SlideTitleContainerPrev = styled.div<{ dim: SlideContainerDimensions }>`
        -ms-grid-row: 1;
        grid-row: 1;
        width: 100%;
        font-size: 1.5em;
        font-weight: 600;
        line-height: 1.6em;
        margin-left: ${props => calcMarginLeft(props.dim)}px;
`;

    public static SlideInsideGridPrev = styled.div<{ dim: SlideContainerDimensions, background: string }>`
        -ms-grid-row: 2;
        grid-row: 2;
        position: relative;
        background: ${props => props.background};
        overflow: auto;
        margin-left: ${props => calcMarginLeft(props.dim)}px;
        width: ${props => (props.dim.viewMode === "Desktop" || props.dim.viewMode === "Tablet horizontal" ? 0.88 : 0.98) * props.dim.width}px;
        height: 100%;
`;
    public static Table = styled.div`
        display: grid;
        grid-template-columns: max-content 1fr;
        column-gap: 20px;
        grid-template-rows: 1fr;
        border: 1px solid ${p => getColor(p, "@middleLightGrey")};
        padding: 10px;
        box-shadow: 0 6px 8px -6px ${p => getColor(p, "@darkGrey")};
`;
    public static Title = styled.div`
        //font-weight: bolder;
        line-height: 40px;
`;
    public static InputContainer = styled.div`
        width: 100%;
        display: grid;
        grid-template-columns: 1fr max-content;
        height: 40px;
        line-height: 40px;
`;
    public static QrContainer = styled.div`
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 3;
        grid-row-end: 8;
        display: grid;
        grid-template-columns: 1fr 160px;
        grid-template-rows: 40px;
`;
    public static QrCode = styled.div`
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 1;
        grid-row-end: 5;
        height: 160px;
`;
    public static FooterLink = styled.div`
        grid-column-start: 1;
        grid-column-end: 3;
        background: ${p => getColor(p, "@veryLightGrey")};
        width: calc(100% + 20px);
        margin-left: -10px;
        margin-top: 10px;
        margin-bottom: -10px;
        display: grid;
        grid-template-columns: max-content 1fr 40px;
    `;
    public static FooterLinkText = styled.div`
        padding: 5px 10px;
        font-size: 12px;    
        line-height: 15px;
`;
    public static FooterLinkTextTitle = styled.div`
        line-height: 40px;
        font-weight: bolder;
        padding: 0px 10px;
`;

    public static InfoBoxContent = styled.div`
    background: ${p => getColor(p, "@mainBackground")};
    border-top: 1px solid ${p => getColor(p, "@middleLightGrey")};
    display: grid;
    grid-template-columns: 30px 1fr;
    line-height: 24px;
    padding: 10px 10px 10px 50px;
`;
    public static InfoBoxButtons = styled.div`
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    height: 42px;
    padding: 0px;
`;
    public static Top = styled.div`
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr max-content;
`;
    public static Footer = styled.div`
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr max-content;
    column-gap: 5px;
`;
    public static ContentPreviewContainer = styled.div<{ width: number }>`
    position: relative;
    background: ${p => getColor(p, "@mainBackground")};
    width: ${p => p.width}px;
    height: ${p => p.width * 9 / 16}px;
    margin: 0px;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    text-align: left;
`;
    public static ContentPreviewTitle = styled.div<{ width: number }>`
    position: absolute;
    left: 0;
    width: ${p => p.width}px;
    top: -41px;
    line-height: 40px;
    font-weight: bolder;
    text-align: left;
    font-size: 1.2em;
`;
    public static ContentPreviewLeft = styled.div<{ width: number, disabled?: boolean }>`
    position: absolute;
    width: 70px;    // in previous version this element blocked buttons of child elements, such as video or audio
    height: calc(${p => p.width * 9 / 16}px - 2px);
    line-height: ${p => p.width * 9 / 16}px;
    text-align: left;
    left: calc((100vw - ${p => p.width}px) / 2);
    top: calc(50% + 2px);
    transform: translate(-70px, -50%);
    transition: all 0.2s ease-out;
    cursor: ${p => p.disabled ? "default" : "pointer"};
    svg{
        stroke: ${p => p.disabled ? getColor(p, "transparent") : getColor(p, "@middleLightGrey")};
        transition: all 0.2s ease-out;
    }
    &:hover{
    svg{
            stroke: ${p => p.disabled ? getColor(p, "transparent") : getColor(p, "@accent")};
            stroke-width: 2px;
        }    
    }
`;
    public static ContentPreviewRight = styled(this.ContentPreviewLeft)`
    left: unset;
    text-align: right;
    right: calc((100vw - ${p => p.width}px) / 2);
    transform: translate(70px, -50%);
`;
    public static OuterContainer = styled.div`
    button>div{margin: 0;}
`;
    public static IconBox = styled.div`
    
`;
    public static Explanation = styled.div`
    
`;
    public static C = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr;
`;
    public static Elem = styled.div`
    font-weight: bold;
`;
    public static TableGrid = styled.div`
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    row-gap: 5px;
    margin-bottom: 5px;
    line-height: 40px;
    button>div{margin: 0;}
`;
    public static SlideSingleCardContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 41px max-content max-content max-content;
    border: 1px solid ${p => getColor(p, "@middleLightGrey")};
    box-shadow: 0 6px 8px -6px ${p => getColor(p, "@lightGrey")};
    background: ${p => getColor(p, "@mainBackground")};
    transition: all 0.2s ease-in-out;
    box-shadow: 0 6px 8px -6px ${p => getColor(p, "@lightGrey")};

    &:hover{
        box-shadow: 0 6px 8px -6px ${p => getColor(p, "@darkerGrey")};
    }
`;

    public static TitleContainer = styled.div`
    line-height: 40px;
    background: ${p => getColor(p, "@veryLightGrey")};
    display: grid;
    grid-template-columns: 40px 1fr max-content;
    border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
`;
    public static TitleNumber = styled.div`
    background: ${p => lightenColor(p, "@veryLightGrey", 98)};
    font-weight: bolder;
`;
    public static TitleText = styled.div`
    background: ${p => lightenColor(p, "@veryLightGrey", 100)};
    padding-left: 10px;
    font-weight: bolder;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
    public static TitlePublicated = styled.div`
    text-align: right;
    padding-right: 10px;
`;
    public static SlidePreviewContainer = styled.div`
    background: ${p => getColor(p, "@mainBackground")};
    padding: 10px 0;
`;
    public static CardContentInfo = styled.div`
    padding: 5px 10px;
    color: ${p => getColor(p, "@accent")};

`;
    public static Extra = styled.div`
    border-top: 1px solid ${p => getColor(p, "@middleLightGrey")};
    background: ${p => getColor(p, "@veryLightGrey")};
    button>div{margin: 0;}
    padding-top: 0px;
`;

    public static ExtraSelect = styled.div`   
    display: grid;
    grid-template-columns: max-content 1fr;
    margin-bottom: -25px;
    column-gap: 10px;
`;
    public static ExtraSelectDescription = styled.div`   
    padding-left: 10px;
    line-height: 40px;
`;
    public static ExtraSelectSelect = styled.div`   
    padding-right: 5px;
`;
    public static PdfImportContainer = styled.div`   
    display: grid;
    grid-template-columns: minmax(150px, max-content) 1fr;
    column-gap: 20px;
    color: ${p => getColor(p, "@darkGrey")};
`;
    public static PdfImportFileName = styled.div<{ noFile: boolean }>`   
    color: ${p => getColor(p, p.noFile ? "@accent" : "inherit")};
`;
}